import {CSSProperties} from 'react';
import {styled} from 'styled-components';

import {applyCommonCss, CommonCssProps, CssSize, sizeToPx} from '@shared_web/components/core2/div';
import {optionalPx} from '@shared_web/lib/styled_utils';

export interface FlexProps extends CommonCssProps {
  // Flags
  $column?: boolean;
  $wrap?: boolean;
  $grow?: boolean;
  $shrink?: boolean;
  // Raw values
  $justify?: CSSProperties['justifyContent'];
  $align?: CSSProperties['alignItems'];
  $alignSelf?: CSSProperties['alignSelf'];
  // CssSize values
  $gap?: CssSize;
}

export const cssGap = (size?: CssSize) => {
  return optionalPx('gap', sizeToPx(size));
};

export const Flex = styled.div<FlexProps>`
  // Base
  display: flex;
  // Flags
  ${p => p.$column && 'flex-direction: column;'}
  ${p => p.$wrap && 'flex-wrap: wrap;'}
  ${p => p.$grow && 'flex-grow: 1; flex-shrink: 0;'}
  ${p => p.$shrink && 'flex-grow: 0; flex-shrink: 1;'}
  // Raw values
  ${p => p.$justify && `justify-content: ${p.$justify};`}
  ${p => p.$align && `align-items: ${p.$align};`}
  ${p => p.$alignSelf && `align-self: ${p.$alignSelf};`}
  // CssSize values
  ${p => cssGap(p.$gap)}
  // Common
  ${p => applyCommonCss(p)}
`;
